export default __webpack_public_path__ + "static/simple_logo-a5bd1b1533fb718705ca9131d7b06212.png";